import * as FetchUtil from "../fetch-util";

export interface LoginRequest {
  username: string;
  password: string;
  rememberMe?: boolean;
}

export interface RecoverRequest {
  username: string;
}
export interface SetNewPasswordRequest {
  password: string;
}

export interface RecoverResponse {
  redirectUrl?: string;
}
export interface ResetResponse {
  message?: string;
}
export interface LoginResponse {
  data?: UpdatePasswordData;
}

interface UpdatePasswordData {
  updatePassword: {
    token: string;
  };
}

export class Authentication {
  static login(request: LoginRequest): Promise<FetchUtil.HttpResponse<LoginResponse>> {
    return FetchUtil.post("/api/v1/authentication/login", request);
  }
  static accountRecover(request: RecoverRequest): Promise<FetchUtil.HttpResponse<RecoverResponse>> {
    return FetchUtil.post("/api/v1/authentication/account-recover", request);
  }
  static setNewPassword(token: string, request: SetNewPasswordRequest): Promise<FetchUtil.HttpResponse<ResetResponse>> {
    return FetchUtil.post(`/api/v1/authentication/account-recover/${token}/update-password`, request);
  }
}
